@if (signedIn) {
  <div class="mod_topnav">
    <ul>
      @if (onAusschreibung || onAngebot) {
        <li routerLink="">
          <a>Meine Ausschreibungen</a>
        </li>
      } @else {
        <li class="var_active">Meine Ausschreibungen</li>
      }
      @if (id != '-1' && (onAusschreibung || onAngebot)) {
        @if (onAngebot) {
          <li [routerLink]="['/ausschreibung', id]">
            <a>{{selectedAusschreibungTitle}}</a>
          </li>
        } @else {
          <li class="var_active">{{selectedAusschreibungTitle}}</li>
        }
      }
      @if (angebot && onAngebot) {
        <li class="var_active">Ihr Angebot</li>
      }
    </ul>
  </div>
}
